export enum Anchors {
  WorkspaceHeader = 'WorkspaceHeader',
  CanvasFormHeader = 'CanvasFormHeader',
  DataMapperHeader = 'DataMapperHeader',
  CanvasGroupTitlebar = 'CanvasGroupTitlebar',
  CanvasNodeTopLeft = 'CanvasNodeTopLeft',
  CanvasToolbar = 'CanvasToolbar',
  SettingsSection = 'SettingsSection',
}
